/**
 * PICKERS VISUAIS
 *
 * Exemplos dos componentes compartilhados usados para escolher atributos
 * visuais sem acoplar semântica de produto ao EP.
 *
 * Fluxo de cor do tutorial:
 * - abre primeiro a Palette compartilhada com as 56 cores do EP;
 * - foreground sempre expõe "Automática";
 * - background sempre expõe "Transparente";
 * - "Mais cores…" sempre existe e abre o ColorPicker avançado.
 *
 * O IconPicker carrega o catálogo completo do Font Awesome Free sob demanda,
 * filtra por Solid/Regular/Brands, pesquisa o catálogo inteiro e devolve
 * { type, name, color }, sempre com name sem o prefixo "fa-".
 */
export const visualPickers = {
  legend: 'ColorPicker & IconPicker',
  isGrid: true,
  cols: 2,
  content: [
    {
      element: 'palette',
      id: 'tutorial-color-picker',
      name: 'tutorialColor',
      label: 'ColorPicker',
      mode: 'foreground',
      value: '#0084FF',
      columns: 8,
      row: 0,
      col: 0
    },
    {
      element: 'iconPicker',
      id: 'tutorial-icon-picker',
      name: 'tutorialIcon',
      label: 'IconPicker',
      value: { type: 'solid', name: 'screwdriver-wrench', color: '#FFFFFF' },
      pageSize: 96,
      row: 0,
      col: 1
    }
  ]
};

export default visualPickers;
